import React, { Fragment } from "react";
import { Col, Container, Row } from "react-bs4grid";
import { withRouter } from "react-router-dom";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import objectToFormData from "object-to-formdata";

import useAppState from "../../../StateMachine/useAppState";
import TextField from "../../../formiks/TextField/TextField";
import ImageUploadField from "../../../formiks/ImageUploadField/ImageUploadField";
import signupFormValidationSchema from "./signupFormValidationSchema";

import "react-phone-number-input/style.css";
import CheckboxField from "../../../formiks/CheckboxField/CheckboxField";
import {useTranslation} from "react-i18next";
import DateInputField from "../../../formiks/DateInputField/DateInputField";

function Signup({ history }) {
  const {t} = useTranslation();
  const account = useAppState("account");
  const countries = [
    { names: ["australia"], code: "+61"},
    { names: ["thailand"], code:"+66"},
    { names: ["malaysia"], code: "+60"},
    { names: ["vietnam"], code:"+84"}
  ];

  return (
    <Fragment>
      <Container>
        <div className="pt-32">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <h1>{t("register")}</h1>
            <Formik
              validationSchema={signupFormValidationSchema}
              initialValues={{
                email: "",
                password: "",
                firstName: "",
                lastName: "",
                phoneNationalNumber: "",
                repeatPassword: "",
                location: "",
                acceptTermsConditions: false,
                ageDeclaration: false,
              }}
              onSubmit={(values, formikActions) => {
                let valid = true;
                const cutoffDate = new Date().setFullYear((new Date().getFullYear()) - 18);
                
                if(cutoffDate < values.dob || values.dob === undefined) {
                  toast.error("You must be over 18 to collect for Plastx.", {autoClose: 5000});
                  formikActions.setSubmitting(false);
                  valid = false;
                }
                if(!values.ageDeclaration) {
                  toast.error("You must make the age declaration.", {autoClose: 5000});
                  formikActions.setSubmitting(false);
                  valid = false;
                }
                if(!values.acceptTermsConditions) {
                  toast.error("You must accept the terms.", {autoClose: 5000});
                  formikActions.setSubmitting(false);
                  valid = false;
                }
                if(!values.profilePhotoFile || values.profilePhotoFile === {}) {
                  toast.error("A profile image is required.", {autoClose: 5000});
                  formikActions.setSubmitting(false);
                  valid = false;
                }
                if(!values.location || !countries.find((c) => c.names.includes(values.location.toLowerCase()))){
                  if(!values.location) {
                    toast.error("A country is required.", {autoClose: 5000});
                  } else {
                    toast.error("Unable to determine country, ensure it is spelled correctly. For Collectors, PlastX is currently only available in Malaysia.")
                  }
                  formikActions.setSubmitting(false);
                  valid = false;
                }

                if(!valid) { return; }
                values.phoneCountryCode = countries.find((c) => c.names.includes(values.location.toLowerCase())).code;
                values.phoneNationalNumber = values.phoneNationalNumber;
                values.location = {fullAddress: values.location};
                const bodyFormData = objectToFormData(values);
                account
                  .signup(bodyFormData)
                  .then(() => {
                    account.login(values).then(res => {
                      history.push("/jobs/my-jobs");
                    })
                    .catch(err => {
                      account.signout().then(() => {
                        history.push("/user/confirm-email");
                      });
                    })
                  })
                  .catch(error => {
                    toast.error("A field was invalid. Please double check your details.", {autoClose: 5000});
                    values.location = values.location.fullAddress;
                    formikActions.setSubmitting(false);
                  });
              }}
              render={({ errors, values, isSubmitting }) => {
                return (
                  <Form>
                    <Container>
                      <Row>
                        <Col>
                          <TextField
                            label={t("firstName")}
                            name="firstName"
                            type="text"
                            placeholder={t("firstName")}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <TextField
                            label={t("lastName")}
                            name="lastName"
                            type="text"
                            placeholder={t("lastName")}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                        <DateInputField
                          label={t("birthDate")}
                          name="dob"
                          type="date"
                        /></Col>
                      </Row>
                      <Row>
                        <Col>
                          <TextField
                            label={t("country")}
                            name="location"
                            placeholder={t("country")}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                        <TextField name="phoneNationalNumber"
                        label={t("phoneNumber")}
                        placeholder={t("phoneNumber")}>
                        </TextField>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <TextField
                            label={t("email")}
                            name="email"
                            type="email"
                            placeholder={t("email")}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <TextField
                            label={t("password")}
                            name="password"
                            type="password"
                            placeholder="********"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <TextField
                            label={t("password")}
                            name="repeatPassword"
                            type="password"
                            placeholder="********"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <ImageUploadField
                            label={t("uploadImage")}
                            name="profilePhotoFile"
                            placeholder={"/default-profile-picture.jpg"}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <CheckboxField
                            label={t("iAccept")}
                            name="acceptTermsConditions"
                            terms="true"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <CheckboxField
                            label={t("declareOver18")}
                            name="ageDeclaration"
                          />
                        </Col>
                      </Row>
                      <Row className="pb-64">
                        <Col>
                          <button
                            className="btn btn-primary"
                            disabled={isSubmitting}
                            type="submit"
                          >
                            {t("register")}
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                );
              }}
            />
          </div>
        </div>
      </Container>
    </Fragment>
  );
}

export default withRouter(Signup);
